angular.module('ihestiaWidgets.commonOperations', [
  'ihestia-widgets-templates-app',
  'salesPath.outer',
  'ihestiaCommonDirectives'
]);